import * as THREE from 'three'
import gsap from 'gsap'

export default class models_world {
    constructor(world) {
        this.world = world
        this.scene = this.world.scenes['scene-1']
        this.resources = this.world.stateController.resources.items
        this.time = this.world.time
        this.debug = this.world.debug
        this.camera = this.world.camera.perspectiveCamera
        this.sizes = this.world.sizes
        this.renderer = this.world.renderer

        //Setup
        this.setDebug()
        this.setTextures()
        this.setMaterials()
        this.setModel()
        this.setAnimation()
    }


    setDebug() {
        // Debug
        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('Models')
            //this.debugFolder.close()
        }
    }

    setTextures() {
    }

    setMaterials() {
        this.outlineMaterial = new THREE.MeshBasicMaterial({ color: 0x000000 })
        this.curveMaterial = new THREE.LineBasicMaterial( { color: 0x0000ff } )
    }

    setModel() {
        //MODELS WORLD GTLF
        this.models_world_gltf = this.resources.models_world_gltf
        this.models_world = this.models_world_gltf.scene
        this.scene.add(this.models_world)
        // console.log(this.models_world)

        this.models_world.traverse((child) =>
        {
            if(child instanceof THREE.Mesh)
            {
                child.castShadow = true
            }
        })

        //////////////////////////////////////////////////////////////////////
        //shared models
        //////////////////////////////////////////////////////////////////////

        //Bomen
        this.tree = this.models_world.getObjectByName('tree_forinstance')
        this.tree.children[0].material = this.outlineMaterial

        //Puin
        this.puin = this.models_world.getObjectByName('puin')
        this.puin.children[1].material = this.outlineMaterial
        this.puin.castShadow = false

        //Huizen & farms
        this.h1 = this.models_world.getObjectByName('H1')
        this.h2 = this.models_world.getObjectByName('H2')
        this.h3 = this.models_world.getObjectByName('H3')
        this.h4 = this.models_world.getObjectByName('H4')
        this.f1 = this.models_world.getObjectByName('F1')
        this.f2 = this.models_world.getObjectByName('F2')

        this.h1.children[1].material = this.outlineMaterial
        this.h2.children[1].material = this.outlineMaterial
        this.h3.children[1].material = this.outlineMaterial
        this.h4.children[1].material = this.outlineMaterial
        this.f1.children[1].material = this.outlineMaterial
        this.f2.children[1].material = this.outlineMaterial

        //Poppetjes
        this.p1 = this.models_world.getObjectByName('P1')
        this.p2 = this.models_world.getObjectByName('P2')
        this.p3 = this.models_world.getObjectByName('P3')
        this.p4 = this.models_world.getObjectByName('P4')
        this.p5 = this.models_world.getObjectByName('P5')

        this.p1.castShadow = false
        this.p2.castShadow = false
        this.p3.castShadow = false
        this.p4.castShadow = false
        this.p5.castShadow = false

        //////////////////////////////////////////////////////////////////////////////////////
        // 1 - Arnhem
        //////////////////////////////////////////////////////////////////////////////////////
        
        //Kerk
        this.eusebiuskerk = this.models_world.getObjectByName('Eusebiuskerk')
        this.eusebiuskerk.children[1].material = this.outlineMaterial

        //Brug
        this.john_frost_brug = this.models_world.getObjectByName('john_frost_brug')
        this.john_frost_brug.children[1].material = this.outlineMaterial

        //Vliegtuig
        this.zweefvliegtuig = this.models_world.getObjectByName('zweefvliegtuig')
        this.zweefvliegtuig.children[1].material = this.outlineMaterial

        //////////////////////////////////////////////////////////////////////////////////////
        // 2 - Ede
        //////////////////////////////////////////////////////////////////////////////////////

        //Truck
        this.truck = this.models_world.getObjectByName('truck')
        this.truck.children[1].material = this.outlineMaterial

        //////////////////////////////////////////////////////////////////////////////////////
        // 3 - Apeldoorn
        //////////////////////////////////////////////////////////////////////////////////////
        
        //Loo
        this.het_loo = this.models_world.getObjectByName('het_loo')
        this.het_loo.children[1].material = this.outlineMaterial

        //////////////////////////////////////////////////////////////////////////////////////
        // 4 - Uddel
        //////////////////////////////////////////////////////////////////////////////////////

        //////////////////////////////////////////////////////////////////////////////////////
        // 5 - Barneveld
        //////////////////////////////////////////////////////////////////////////////////////
        
        //Schaffelaar
        this.huize_schaffelaar = this.models_world.getObjectByName('huize_schaffelaar')
        this.huize_schaffelaar.children[1].material = this.outlineMaterial

        //////////////////////////////////////////////////////////////////////////////////////
        // 6 - Wageningen
        //////////////////////////////////////////////////////////////////////////////////////
        
        //Huifkar
        this.kar = this.models_world.getObjectByName('kar')
        this.kar.children[1].material = this.outlineMaterial

        //////////////////////////////////////////////////////////////////////////////////////
        // 7 - Renkum
        //////////////////////////////////////////////////////////////////////////////////////
        
        //Nol in het bosch
        this.nol = this.models_world.getObjectByName('nol_in_het_bosch')
        this.nol.children[1].material = this.outlineMaterial

        //Bootjes
        this.bootje = this.models_world.getObjectByName('bootje')
        this.bootje.children[1].material = this.outlineMaterial

        //////////////////////////////////////////////////////////////////////////////////////
        // 8 - Nijmegen
        //////////////////////////////////////////////////////////////////////////////////////

        //Brug
        this.nijmegen_brug = this.models_world.getObjectByName('nijmegen_brug')
        this.nijmegen_brug.children[1].material = this.outlineMaterial

        //////////////////////////////////////////////////////////////////////////////////////
        //B24
        //////////////////////////////////////////////////////////////////////////////////////
        // gltf animation
        this.airplane_b24_gltf = this.resources.airplane_b24_gltf
        this.airplane_b24_model = this.airplane_b24_gltf.scene
        this.scene.add(this.airplane_b24_model)

        //Naming the planes
        this.airplane_b24 = this.airplane_b24_model.getObjectByName('Formatievliegen')
        this.b24_hitbox = this.airplane_b24_model.getObjectByName('B24_hitbox')
        this.b24_hitbox.visible = false
        this.b24 = this.airplane_b24_model.getObjectByName('B24J_bommenwerper')

        //Outline materials
        this.b24.children[1].material = this.outlineMaterial

        //scaling the airplanes
        this.airplane_b24.scale.set(0.1, 0.1, 0.1)
        this.airplane_b24.position.set(0,1.3,0)

        //////////////////////////////////////////////////////////////////////////////////////
        //spitfire
        //////////////////////////////////////////////////////////////////////////////////////
        // gltf animation
        this.airplane_spitfire_gltf = this.resources.airplane_spitfire_gltf
        this.airplane_spitfire_model = this.airplane_spitfire_gltf.scene
        this.scene.add(this.airplane_spitfire_model)

        //Naming the planes
        this.airplane_spitfire = this.airplane_spitfire_model.getObjectByName('spitfire')
        this.spitfire_hitbox = this.airplane_spitfire_model.getObjectByName('spitfire_hitbox')
        this.spitfire_hitbox.visible = false
        this.spitfire = this.airplane_spitfire_model.getObjectByName('spitfire_ani')

        //Outline materials
        this.spitfire.children[1].material = this.outlineMaterial

        //scaling the airplanes
        this.airplane_spitfire.scale.set(0.12, 0.12, 0.12)
        this.airplane_spitfire.position.y = 1.3

        //////////////////////////////////////////////////////////////////////////////////////
        //bom animatie
        //////////////////////////////////////////////////////////////////////////////////////
        this.bom_animatie_gltf = this.resources.bom_animatie_gltf
        this.bom_animatie_model = this.bom_animatie_gltf.scene
        this.scene.add(this.bom_animatie_model)
        
        ///////////////////////////////////////////////////////////////////////////////////////////////
        //curve b24
        ///////////////////////////////////////////////////////////////////////////////////////////////
        this.curve_b24 = new THREE.CatmullRomCurve3( [
            new THREE.Vector3( 0, 1.3, 10 ),
            new THREE.Vector3( 5, 1.3, 5 ),
            new THREE.Vector3( 5, 1.3, 0 ),
            new THREE.Vector3( 5, 1.3, -5 ),
            new THREE.Vector3( -2, 1.3, -10 ),
            new THREE.Vector3( -8, 1.3, -7 ),
            new THREE.Vector3( -6, 1.3, 0 ),
            new THREE.Vector3( -6, 1.3, 7 ),
        ])

        // Spline
        this.curve_b24.closed = true
        this.curve_b24_points = this.curve_b24.getPoints( 100 )
        this.curve_b24_geometry = new THREE.BufferGeometry().setFromPoints( this.curve_b24_points )

        // Create the final object to add to the scene
        this.curve_b24_object = new THREE.Line( this.curve_b24_geometry, this.curveMaterial )
        this.curve_b24_object.visible = false
        this.scene.add(this.curve_b24_object)

        ///////////////////////////////////////////////////////////////////////////////////////////////
        //curve spitfire
        ///////////////////////////////////////////////////////////////////////////////////////////////
        this.curve_spitfire = new THREE.CatmullRomCurve3( [
            new THREE.Vector3( 8, 1.3, 3 ),
            new THREE.Vector3( 2, 1.3, -8 ),
            new THREE.Vector3( -7, 1.3, 2 ),
            new THREE.Vector3( 0, 1.3, 7 ),
        ]);
  
        // Spline
        this.curve_spitfire.closed = true
        this.curve_spitfire_points = this.curve_spitfire.getPoints( 100 )
        this.curve_spitfire_geometry = new THREE.BufferGeometry().setFromPoints( this.curve_spitfire_points )

        // Create the final object to add to the scene
        this.curve_spitfire_object = new THREE.Line( this.curve_spitfire_geometry, this.curveMaterial )
        this.curve_spitfire_object.visible = false
        this.scene.add(this.curve_spitfire_object)

        ///////////////////////////////////////////////////////////////////////////////////////////////
        //curve variabelen
        ///////////////////////////////////////////////////////////////////////////////////////////////
        this.curve_position_b24 = new THREE.Vector3()
        this.curve_rotation_b24 = new THREE.Vector3()
        this.curve_position_spitfire = new THREE.Vector3()
        this.curve_rotation_spitfire = new THREE.Vector3()
        this.lerp = {
            current: 0,
            target: 0,
            ease: 0
        }

        ///////////////////////////////////////////////////////////////////////////////////////////////
        //debug
        ///////////////////////////////////////////////////////////////////////////////////////////////
        if (this.debug.active) {
            this.debugFolder.add(this.airplane_b24, 'visible').name('B24 model')
            this.debugFolder.add(this.airplane_spitfire, 'visible').name('Spitfire model')
            this.debugFolder.add(this.curve_b24_object, 'visible').name('B24 curve')
            this.debugFolder.add(this.curve_spitfire_object, 'visible').name('Spitfire curve')
        }
    }

    setAnimation() {
        //Animatie mixer per object
        this.animation = {}
        this.animation.mixer_b24 = new THREE.AnimationMixer(this.airplane_b24_model)
        this.animation.mixer_spitfire = new THREE.AnimationMixer(this.airplane_spitfire_model)
        //bom
        this.animation.mixer_bom = new THREE.AnimationMixer(this.bom_animatie_model)

        //groeperen van alle animaties
        this.animation.actions = {}

        //Animaties
        this.animation.actions.fly_b24 = this.animation.mixer_b24.clipAction(this.airplane_b24_gltf.animations[0])
        this.animation.actions.fly_spitfire = this.animation.mixer_spitfire.clipAction(this.airplane_spitfire_gltf.animations[0])
        //bom
        this.animation.actions.bom = this.animation.mixer_bom.clipAction(this.bom_animatie_gltf.animations[0])

        //Afspelen van de animaties
        this.animation.actions.fly_b24.play()
        this.animation.actions.fly_spitfire.play()

        //Only play the animation once
        this.animation.actions.bom.setLoop(THREE.LoopOnce)
        this.animation.actions.bom.setDuration(2)

        //play animation on spacebar
        document.addEventListener('keydown', (event) => {
            if (event.code === 'Space' && this.world.world.raycast.b24_follow === true) {
                if (this.animation.actions.bom.isRunning()){
                    return
                } else {
                    if( this.world.world.audio.explosion_sound.isPlaying === true){
                        this.world.world.audio.explosion_sound.stop()
                    }
                    
                    this.world.world.audio.explosion_sound.play(2)

                    this.animation.actions.bom.stop()
                    this.animation.actions.bom.play()       
                }
            }
        })

        //Cheat codes
        const konamiCode = [37, 37, 39, 39, 38, 40];
        let konamiIndex = 0;

        document.addEventListener('keydown', function(event) {
        if (event.keyCode === konamiCode[konamiIndex]) {
            konamiIndex++;
            
            if (konamiIndex === konamiCode.length) {
            konamiCodeFunction();
            konamiIndex = 0;
            }
        } else {
            konamiIndex = 0;
        }
        });

        function konamiCodeFunction() {
            console.log('Good Try!');
        }
    }

    update() {
        //Animation mixer update
        this.animation.mixer_b24.update(this.time.delta * 0.001)
        this.animation.mixer_spitfire.update(this.time.delta * 0.001)
        this.animation.mixer_bom.update(this.time.delta * 0.001)

        //vliegtuig op curve animatie
        //this.lerp.target += 0.0005 
        this.lerp.current = this.lerp.target

        //looping the animation
        if(this.lerp.target >= 1-0.000001){
            this.lerp.target = 0
        }
 
        //clamp zodat object op de curve blijft
        this.lerp.target = gsap.utils.clamp(0, 1, this.lerp.target)
        this.lerp.current = gsap.utils.clamp(0, (1-0.000001), this.lerp.current)

        //object moving on curve
        //b24
        this.curve_b24.getPointAt(this.lerp.current, this.curve_position_b24)
        this.curve_b24.getPointAt(this.lerp.current + 0.000001, this.curve_rotation_b24)
        //spitfire
        this.curve_spitfire.getPointAt(this.lerp.current, this.curve_position_spitfire)
        this.curve_spitfire.getPointAt(this.lerp.current + 0.000001, this.curve_rotation_spitfire)
        
        //linking the animation to the airplanes
        this.airplane_b24.position.copy(this.curve_position_b24)
        this.airplane_b24.lookAt(this.curve_rotation_b24)
        this.airplane_spitfire.position.copy(this.curve_position_spitfire)   
        this.airplane_spitfire.lookAt(this.curve_rotation_spitfire)

        //bom position
        this.bom_animatie_model.position.copy(this.airplane_b24.position)
        this.bom_animatie_model.lookAt(this.curve_rotation_b24)

        //setting up dynamic quility
        if (this.renderer.high === true) {
            this.animation.actions.fly_b24.play()
            this.animation.actions.fly_spitfire.play()
            this.lerp.target += 0.0005
            this.tree.visible = true

        } if (this.renderer.medium === true) {
            this.animation.actions.fly_b24.play()
            this.animation.actions.fly_spitfire.play()
            this.lerp.target += 0.0005
            this.tree.visible = true
        
        } if (this.renderer.low === true) {
            this.animation.actions.fly_b24.stop()
            this.animation.actions.fly_spitfire.stop()
            this.lerp.target = 0
            this.tree.visible = false
        }
    } 
}



